import React, { createContext, useContext, useState } from 'react';
import axiosInstance from '../../../../../api/axiosInstance';
import { useToast } from '@chakra-ui/react';
import { saveAs } from 'file-saver';
import { SertifikatPengetahuanPresenter } from '../../../../../../data/presenters/SertifikatPengetahuanPresenter';
import { container } from 'tsyringe';
interface Option {
  label: string;
  value: number;
}
interface IState {
  state: {
    url: string;
    isLoading: boolean;
    listData: [];
    page: number;
    perPage: number;
    search: string;
    isLoadingDownload: { [key: string]: boolean };
    jumlahData: number;
    isOpenModalSertifikat: boolean;
    accountTTESelected: Option | null;
    isLoadingTTEPengetahuan: boolean;
    isOpenModalTteSertifikat: boolean;
    ttePengetahuanId: number | null;
    tteUserId: number | null;
    isLoadingGenerateExcel: boolean;
    isGenerateJobRunning: boolean;
    generatePengetahuanId: number | null;
    isLoadingDownloadExcel: boolean;
    isTteUlang: boolean;
    isLoadingDelete: { [key: string]: boolean };
  };
  dispatch: {
    setPengetahuanDaftarPeserta: Function;
    fetchData: Function;
    downloadFileAssessment: Function;
    generateExcel: Function;
    downloadExcel: Function;
    tteSertifikatPengetahuan: Function;
    deletePeserta: Function;
  };
}

const initialState: IState = {
  state: {
    url: 'management_content/pengetahuan/',
    isLoading: false,
    listData: [],
    isLoadingDownload: {},
    page: 1,
    perPage: 10,
    search: '',
    jumlahData: 0,
    isOpenModalSertifikat: false,
    accountTTESelected: null,
    isLoadingTTEPengetahuan: false,
    isOpenModalTteSertifikat: false,
    ttePengetahuanId: null,
    tteUserId: null,
    isLoadingGenerateExcel: false,
    isGenerateJobRunning: false,
    generatePengetahuanId: null,
    isLoadingDownloadExcel: false,
    isTteUlang: false,
    isLoadingDelete: {},
  },
  dispatch: {
    setPengetahuanDaftarPeserta: () => { },
    fetchData: () => { },
    downloadFileAssessment: () => { },
    generateExcel: () => { },
    downloadExcel: () => { },
    tteSertifikatPengetahuan: () => { },
    deletePeserta: () => { },
  },
};

const Context = createContext<IState>(initialState);
const { Provider: ManajemenPengetahuanDaftarPesertaProvider } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = useState<IState>(initialState);
  const toast = useToast();

  const {
    url,
    page,
    perPage,
    search,
    accountTTESelected,
    ttePengetahuanId,
    tteUserId,
    isTteUlang
  } = state.state;
  const setPengetahuanDaftarPeserta = (
    key: keyof IState['state'],
    value: any
  ) => {
    setState((prevState) => ({
      ...prevState,
      state: {
        ...prevState.state,
        [key]: value,
      },
    }));
  };

  const fetchData = async (id: string) => {
    setPengetahuanDaftarPeserta('isLoading', true);

    try {
      const response = await axiosInstance.get(url + id + `/peserta`, {
        params: {
          page,
          per_page: perPage,
          keyword: search,
        },
      });

      setPengetahuanDaftarPeserta('listData', response.data?.data);
      setPengetahuanDaftarPeserta('isLoading', false);
      setPengetahuanDaftarPeserta('jumlahData', response.data.total);
    } catch (error) {
      setPengetahuanDaftarPeserta('isLoading', false);
    }
  };

  const downloadFileAssessment = async (
    id: string,
    userId: string,
    fileName: string,
    rowId: string
  ) => {
    setPengetahuanDaftarPeserta('isLoadingDownload', {
      ...state.state.isLoadingDownload,
      [rowId]: true,
    });

    try {
      const response = await axiosInstance.get(
        `management_content/pengetahuan/peserta/${id}/${userId}/file/download`,
        {
          responseType: 'blob',
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');

      link.href = url;

      link.setAttribute('download', `${fileName}`);

      document.body.appendChild(link);

      link.click();

      link.parentNode?.removeChild(link);

      // Revoke the object URL after the download
      window.URL.revokeObjectURL(url);
    } catch (error) {
      throw error;
    } finally {
      setPengetahuanDaftarPeserta('isLoadingDownload', true);
    }
  };

  const generateExcel = async (id) => {
    setPengetahuanDaftarPeserta('isLoadingGenerateExcel', true);
    setPengetahuanDaftarPeserta('isGenerateJobRunning', true);

    try{
      const response = await axiosInstance.get(`${url}${id}/peserta/generate`);

      toast({
          title: response?.data?.message ?? 'Proses generate sedang berjalan',
          status: 'success',
          position: 'top-right',
          duration: 3000,
          isClosable: true,
      });
    } catch (error: any) {
      setPengetahuanDaftarPeserta('isGenerateJobRunning', false);
      const title = error.response?.data?.message || 'Terjadi kesalahan saat mengirim data'
      toast({
        title: 'Error',
        description: title,
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setPengetahuanDaftarPeserta('isLoadingGenerateExcel', false);
    }
  }

  const downloadExcel = async (id) => {
    setPengetahuanDaftarPeserta('isLoadingDownloadExcel', true);
    
    try{
      const response = await axiosInstance.get(`${url}${id}/peserta/download`);

      if (response.status === 200) {
        saveAs(
          response.data.data.path_file_url,
          response.data.data.file_name
        );
        toast({
            title: response?.data?.message ?? 'Berhasil! Excel telah didownload.',
            status: 'success',
            position: 'top-right',
            duration: 3000,
            isClosable: true,
        });
      }
    } catch (error: any) {
      const title = error.response?.data?.message || 'Terjadi kesalahan saat mengirim data'
      toast({
        title: 'Error',
        description: title,
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setPengetahuanDaftarPeserta('isLoadingDownloadExcel', false);
    }
  }

  const tteSertifikatPengetahuan = async () => {
    setPengetahuanDaftarPeserta('isLoadingTTEPengetahuan', true);

    if (accountTTESelected === null) {
      toast({
        description: 'Akun TTE Tidak Boleh Kosong!',
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
      setPengetahuanDaftarPeserta('isLoadingTTEPengetahuan', false);
      return;
    }

    if (ttePengetahuanId === null || tteUserId === null) {
      toast({
        description: 'Data tidak lengkap untuk generate TTE.',
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const sertifikatPengetahuanTTEPresenter = container.resolve(SertifikatPengetahuanPresenter);
      const response = await sertifikatPengetahuanTTEPresenter.tteSertifikatPengetahuan(
        ttePengetahuanId,
        isTteUlang,
        accountTTESelected.value,
        tteUserId,
        true,
      );

      if (response.status === 200) {
        const successMessage = isTteUlang
          ? 'Berhasil! Sertifikat telah diregenerate'
          : 'Berhasil! Sertifikat telah digenerate.';

        toast({
          title: successMessage,
          status: 'success',
          position: 'top-right',
          duration: 3000,
          isClosable: true,
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error: any) {
      console.log('error saat tte sertifikat :', error);
      const title = error.response?.data?.message ||
        'Terjadi kesalahan saat menyimpan data';

      toast({
        title: 'Error',
        description: title,
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setPengetahuanDaftarPeserta('isLoadingTTEPengetahuan', false);
    }
  };

  const deletePeserta = async (pengetahuanSayaId: number, pengetahuanId: string) => {
    setPengetahuanDaftarPeserta('isLoadingDelete', {
      ...state.state.isLoadingDelete,
      [pengetahuanSayaId]: true,
    });

    try {
      const response = await axiosInstance.delete(
        `management_content/pengetahuan_saya/${pengetahuanSayaId}`
      );

      toast({
        title: response?.data?.message ?? 'Berhasil menghapus peserta',
        status: 'success',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });

      // Refresh data after delete
      await fetchData(pengetahuanId);
    } catch (error: any) {
      const title = error.response?.data?.message || 'Terjadi kesalahan saat menghapus data';
      toast({
        title: 'Error',
        description: title,
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setPengetahuanDaftarPeserta('isLoadingDelete', {
        ...state.state.isLoadingDelete,
        [pengetahuanSayaId]: false,
      });
    }
  };


  return (
    <ManajemenPengetahuanDaftarPesertaProvider
      value={{
        state: state.state,
        dispatch: {
          setPengetahuanDaftarPeserta,
          fetchData,
          downloadFileAssessment,
          generateExcel,
          downloadExcel,
          tteSertifikatPengetahuan,
          deletePeserta,
        },
      }}
    >
      {children}
    </ManajemenPengetahuanDaftarPesertaProvider>
  );
};

export const useManajemenPengetahuanDaftarPesertaContext = () =>
  useContext(Context);

const ManajemenPengetahuanDaftarPesertaController = {
  useManajemenPengetahuanDaftarPesertaContext,
  Provider,
};

export default ManajemenPengetahuanDaftarPesertaController;
